
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IQualificationSurveyModel, IQualificationSurveyErrorModel, IQualificationQuestionModel, IQualificationSurveySubmitModel } from '@/models/survey.model';

  import accountService from '@/services/account.service';
  import routeService from '@/services/route.service';
  import tokenService from '@/services/token.service';

  import { IConnectModel } from "@/models/account.model";

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'token',
        'user',
        'connects',
      ])
    }
  })
  export default class QualificationSurvey extends Vue {
    data() {
      return {
        isSendLoading: false,
        currentStep: 0,
        completionSteps: [
          {
            'Age': false,
            'Gender': false,
            'Country': false
          },
          {
            'DevType': false
          },
          {
            'FavoriteFeatures': false
          },
          {
            'SocialNetworks': false
          },
          {
            'Gameinformationources': false
          },
          {
            'Influencers': false
          },
          {
            'GamingWebsites': false
          },
          {
            'Reviews_GamingWebsite': false,
            'Reviews_Influencers': false,
            'Reviews_Steam': false
          },
          {
            'OtherStudios': false
          },
          {
            'AdditionnalMessage': true
          }
        ],
        ages: [
          { Id: "under_18", Value: "1", Label: "Under 18" } as IQualificationQuestionModel,
          { Id: "19_to_24", Value: "2", Label: "19 to 24" } as IQualificationQuestionModel,
          { Id: "25_to_34", Value: "3", Label: "25 to 34" } as IQualificationQuestionModel,
          { Id: "over_34", Value: "4", Label: "Over 34 and proud to be!" } as IQualificationQuestionModel,
        ],
        genders: [
          { Id: "lady", Value: "1", Label: "You can call me lady" } as IQualificationQuestionModel,
          { Id: "man", Value: "2", Label: "I'm a dude" } as IQualificationQuestionModel,
          { Id: "gender_other", Value: "3", Label: "Other" } as IQualificationQuestionModel,
        ],
        devTypes: [
          { Id: "game_designer", Value: "1", Label: "Game Designer", Description: "Loves creating rules, twisting them, breaking them to create new ones. Developers love their creativity!" } as IQualificationQuestionModel,
          { Id: "graphic_artist", Value: "2", Label: "Graphic Artist", Description: "Transforms thoughts into a vibrant pictures worth a thousand words. Usually includes a digital pen." } as IQualificationQuestionModel,
          { Id: "developer", Value: "3", Label: "Developer", Description: "Can not only read the matrix but can also make it evolve. They come in handy when creating a game." } as IQualificationQuestionModel,
          { Id: "writer", Value: "4", Label: "Writer", Description: "&laquo;Once upon a time, in a galaxy far far away...&raquo; Felt like somewhere else for a sec? That's their thing!" } as IQualificationQuestionModel,
          { Id: "producer", Value: "5", Label: "Producer", Description: "Conductors for the ever-changing show of creating video games. A whip can sometimes help..." } as IQualificationQuestionModel,
          { Id: "musician", Value: "6", Label: "Musician", Description: "Combines sounds to create expressions of emotions. Some call it science, others art." } as IQualificationQuestionModel,
        ],
        isCountriesFocused: false,
        isCountriesLabeled: false,
        selectedCountries: [],
        countries: ['United States', 'Germany', 'United Kingdom', 'China', 'France', 'Canada', 'Australia', 'Russian Federation', 'Korea, Republic of', 'Netherlands',
          'Poland', 'Sweden', 'Spain', 'Austria', 'Finland', 'Denmark', 'Japan', 'Taiwan', 'Norway', 'Switzerland', 'Brazil', 'Belgium', 'Italy', 'New Zealand',
          'Czech Republic', 'Hungary', 'Singapore', 'Ireland', 'Hong Kong', 'Ukraine', 'Thailand', 'South Africa', 'Turkey', 'Argentina', 'Portugal', 'Mexico',
          'Romania', 'Israel', 'Greece', 'Malaysia', 'Slovakia (Slovak Republic)', 'Chile', 'Estonia', 'Belarus', 'Philippines', 'Indonesia', 'Bulgaria', 'Croatia',
          'Lithuania', 'Latvia', 'Slovenia', 'Iceland', 'India', 'Luxembourg', 'Viet Nam', 'Kazakhstan', 'Uruguay', 'Peru', 'Serbia', 'Malta', 'United Arab Emirates',
          'Colombia', 'Reunion', 'Costa Rica', 'Puerto Rico', 'New Caledonia', 'Guernsey', 'Brunei Darussalam', 'Jersey', 'Moldova, Republic of', 'Saudi Arabia', 'Qatar',
          'Cyprus', 'Kuwait', 'Ecuador', 'Lebanon', 'Bosnia And Herzegowina', 'Barbados', 'French Guiana', 'Macau', 'Guatemala', 'Cambodia', 'Venezuela', 'Myanmar (Burma)',
          'Pakistan', 'Sri Lanka', 'Trinidad And Tobago', 'Dominican Republic', 'Namibia', 'Jordan', 'Georgia', 'Andorra', 'Montenegro', 'Faroe Islands', 'Guadeloupe',
          'Nicaragua', 'Bahrain', 'Cayman Islands', 'Panama', 'Egypt', 'Liechtenstein', 'Morocco', 'Belize', 'French Polynesia', 'Greenland', 'Mauritius', 'Bermuda',
          'Algeria', 'Jamaica', 'Oman', 'Seychelles', 'Martinique', 'Isle of Man', 'Azerbaijan', 'Maldives', 'Honduras', 'Kenya', 'Fiji', 'Armenia', 'Kyrgyzstan',
          'Paraguay', 'Virgin Islands (U.S.)', 'Uzbekistan', 'Tanzania, United Republic of', 'Saint Lucia', 'Afghanistan', 'Northern Mariana Islands', 'El Salvador',
          'Bahamas', 'Albania', 'Angola', 'Aruba', 'Bangladesh', 'Bolivia', 'Mauritania', 'Mongolia', 'Mozambique', 'Macedonia', 'Gibraltar', 'Guyana', 'Iraq'
        ],
        favoriteFeatures: [
          { Id: "dev_blogs", Value: "Dev Blogs", Label: "Dev Blogs" } as IQualificationQuestionModel,
          { Id: "forums", Value: "Forums", Label: "Forums" } as IQualificationQuestionModel,
          { Id: "ideas", Value: "Ideas", Label: "Ideas" } as IQualificationQuestionModel,
          { Id: "votes", Value: "Votes", Label: "Votes" } as IQualificationQuestionModel,
          { Id: "contests", Value: "Contests", Label: "Contests" } as IQualificationQuestionModel,
          { Id: "tutorials", Value: "Tutorials", Label: "Tutorials" } as IQualificationQuestionModel,
          { Id: "help", Value: "Help", Label: "Help" } as IQualificationQuestionModel,
        ],
        socialNetworks: [
          { Id: "twitter", Value: "Twitter", Label: "Twitter" } as IQualificationQuestionModel,
          { Id: "discord", Value: "Discord", Label: "Discord" } as IQualificationQuestionModel,
          { Id: "facebook", Value: "Facebook", Label: "Facebook" } as IQualificationQuestionModel,
          { Id: "reddit", Value: "Reddit", Label: "Reddit" } as IQualificationQuestionModel,
          { Id: "instagram", Value: "Instagram", Label: "Instagram" } as IQualificationQuestionModel,
          { Id: "youtube", Value: "Youtube", Label: "Youtube" } as IQualificationQuestionModel,
          { Id: "twitch", Value: "Twitch", Label: "Twitch" } as IQualificationQuestionModel,
          { Id: "snap", Value: "SnapChat", Label: "SnapChat" } as IQualificationQuestionModel,
        ],
        gameinformationources: [
          { Id: "lets_play", Value: "Let's Plays", Label: "Let's Plays" } as IQualificationQuestionModel,
          { Id: "video_guides", Value: "Video Guides", Label: "Video Guides" } as IQualificationQuestionModel,
          { Id: "written_guides", Value: "Written Guides", Label: "Written Guides" } as IQualificationQuestionModel,
          { Id: "wikis", Value: "Wikis", Label: "Wikis" } as IQualificationQuestionModel,
          { Id: "discussions", Value: "Discussions", Label: "Discussions" } as IQualificationQuestionModel,
        ],
        gamingWebsites: [
          { Id: "rock_paper_shotgun", Value: "Rock Paper Shotgun", Label: "Rock Paper Shotgun" } as IQualificationQuestionModel,
          { Id: "IGN", Value: "IGN", Label: "IGN" } as IQualificationQuestionModel,
          { Id: "PCGamer", Value: "PCGamer", Label: "PCGamer" } as IQualificationQuestionModel,
          { Id: "kotaku", Value: "Kotaku", Label: "Kotaku" } as IQualificationQuestionModel,
          { Id: "eurogamer", Value: "Eurogamer", Label: "Eurogamer" } as IQualificationQuestionModel,
          { Id: "gamespot", Value: "Gamespot", Label: "Gamespot" } as IQualificationQuestionModel,
          { Id: "VG247", Value: "VG247", Label: "VG247" } as IQualificationQuestionModel,
          { Id: "destructoid", Value: "Destructoid", Label: "Destructoid" } as IQualificationQuestionModel,
          { Id: "computerbild_de", Value: "Computerbild_de", Label: "Computerbild_de" } as IQualificationQuestionModel,
          { Id: "gamestar_de", Value: "Gamestar_de", Label: "Gamestar_de" } as IQualificationQuestionModel,
          { Id: "pcgames_de", Value: "Pcgames_de", Label: "Pcgames_de" } as IQualificationQuestionModel,
          { Id: "giga_de", Value: "Giga_de", Label: "Giga_de" } as IQualificationQuestionModel,
          { Id: "playground_ru", Value: "Playground_ru", Label: "Playground_ru" } as IQualificationQuestionModel,
          { Id: "kanobu_ru", Value: "Kanobu_ru", Label: "Kanobu_ru" } as IQualificationQuestionModel,
          { Id: "game_game_com_ua", Value: "Game_game_com_ua", Label: "Game_game_com_ua" } as IQualificationQuestionModel,
          { Id: "gamer_no", Value: "Gamer_no", Label: "Gamer_no" } as IQualificationQuestionModel,
          { Id: "jeuxvideo_com", Value: "Jeuxvideo_com", Label: "Jeuxvideo_com" } as IQualificationQuestionModel,
          { Id: "canard_pc", Value: "Canard_PC", Label: "Canard_PC" } as IQualificationQuestionModel,
          { Id: "gamekult", Value: "Gamekult", Label: "Gamekult" } as IQualificationQuestionModel,
          { Id: "gameblog", Value: "Gameblog", Label: "Gameblog" } as IQualificationQuestionModel,
        ],
        reviewsGamingSite: [
          { Id: "gaming_site_reviews_i_dont_care", Value: "1", Label: "I don't care" } as IQualificationQuestionModel,
          { Id: "gaming_site_reviews_not_that_much", Value: "2", Label: "Not that much" } as IQualificationQuestionModel,
          { Id: "gaming_site_reviews_its_helps", Value: "3", Label: "It helps" } as IQualificationQuestionModel,
          { Id: "gaming_site_reviews_cant_decide_without_them", Value: "4", Label: "Can't decide without them" } as IQualificationQuestionModel,
        ],
        reviewsInfluencers: [
          { Id: "influencer_reviews_i_dont_care", Value: "1", Label: "I don't care" } as IQualificationQuestionModel,
          { Id: "influencer_reviews_not_that_much", Value: "2", Label: "Not that much" } as IQualificationQuestionModel,
          { Id: "influencer_reviews_its_helps", Value: "3", Label: "It helps" } as IQualificationQuestionModel,
          { Id: "influencer_reviews_cant_decide_without_them", Value: "4", Label: "Can't decide without them" } as IQualificationQuestionModel,
        ],
        reviewsSteam: [
          { Id: "steam_reviews_i_dont_care", Value: "1", Label: "I don't care" } as IQualificationQuestionModel,
          { Id: "steam_reviews_not_that_much", Value: "2", Label: "Not that much" } as IQualificationQuestionModel,
          { Id: "steam_reviews_its_helps", Value: "3", Label: "It helps" } as IQualificationQuestionModel,
          { Id: "steam_reviews_cant_decide_without_them", Value: "4", Label: "Can't decide without them" } as IQualificationQuestionModel,
        ],
        survey: {
          HasOtherFavoriteFeature: false,
          HasOtherSocialNetworks: false,
          HasOtherGameinformationources: false,
          HasOtherGamingWebsites: false,
          Errors: {
          } as IQualificationSurveyErrorModel
        } as IQualificationSurveyModel,
      }
    };

    created() {
      if (tokenService.hasToken(this) == null) {
        routeService.redirectToLogin(this, this.$router.currentRoute.path);
      }
    }

    updateStepStatus(step: number, parameter: string) {
      const completionSteps = this.$data.completionSteps[step];
      completionSteps[parameter] = true;
      this.$set(this.$data.survey.Errors, parameter, false);

      var completions = Object.keys(completionSteps).map(key => completionSteps[key]);
      if (!completions.includes(false) && this.$data.currentStep <= step && this.$data.currentStep < this.$data.completionSteps.length) {
        this.$data.currentStep++;
      }
    }

    focusCountries() {
      this.$data.isCountriesFocused = true;
    }

    blurCountries(event: FocusEvent) {
      const value = (<HTMLInputElement>event.target).value;
      this.$data.isCountriesFocused = false;
      this.$data.isCountriesLabeled = value != null && value != "";
    }

    autocompleteCountries(event: KeyboardEvent) {
      const value = (<HTMLInputElement>event.target).value;
      this.$data.selectedCountries = [];

      if (value != null && value != '') {
        const countries = this.$data.countries.filter((country: string) => new RegExp(value, 'i').test(country)).slice(0, 5);

        countries.forEach((country: string) => {
          this.$data.selectedCountries.push(country.replace(new RegExp('(' + value + ')', 'i'), '<span class="highlight">$1</span>'));
        });
      }
    }

    selectCountry(event: MouseEvent) {
      const value = (<HTMLInputElement>event.target).textContent;
      this.$data.survey.Country = value;
      this.updateStepStatus(0, 'Country');
    }

    addFavoriteFeature(feature: string, hasOtherFavoriteFeature: boolean = false) {
      this.$set(this.$data.survey, 'HasOtherFavoriteFeature', hasOtherFavoriteFeature);
      this.$set(this.$data.survey, 'FavoriteFeatures', [feature]);

      this.updateStepStatus(2, 'FavoriteFeatures');
    }

    addOtherFavoriteFeature(parameter: string, feature: string) {
      this.addFavoriteFeature(feature == "" ? "Something else" : feature, true);
    }

    updateParameter(parameter: string, otherParameterReference: string, hasOtherParameterReference: string, parameterValue: string, checked: boolean, step: number) {
      if (this.$data.survey[parameter] == null) {
        this.$set(this.$data.survey, parameter, []);
      }

      if (parameterValue == 'Other') {
        if (!checked) {
          this.$set(this.$data.survey, otherParameterReference, null);
          this.$set(this.$data.survey, hasOtherParameterReference, false);
        }
        else {
          this.$set(this.$data.survey, otherParameterReference, 'Other');
          this.$set(this.$data.survey, hasOtherParameterReference, true);
        }
      }
      else {
        let parameterArray = this.$data.survey[parameter];

        if (!this.$data.survey[parameter].includes(parameterValue) && checked) {
          parameterArray.push(parameterValue);
        }
        else if (this.$data.survey[parameter].includes(parameterValue) && !checked) {
          parameterArray.splice(parameterArray.indexOf(parameterValue), 1);
        }

        this.$set(this.$data.survey, parameter, parameterArray);
      }

      this.updateStepStatus(step, parameter);
    }

    updateOtherParameter(parameter: string, otherParameterReference: any, hasOtherParameterReference: any, parameterValue: string, step: number) {
      this.$data.survey[hasOtherParameterReference] = true;
      this.$data.survey[otherParameterReference] = parameterValue != '' ? parameterValue : 'Other';

      this.updateStepStatus(step, parameter);
    }

    updateSocialNetworksEvent(event: MouseEvent) {
      const target = <HTMLInputElement>event.target;
      this.updateParameter('SocialNetworks', 'OtherSocialNetworks', 'HasOtherSocialNetworks', target.value, target.checked, 3);
    }

    updateOtherSocialNetworks(parameter: string, socialNetwork: string) {
      this.updateOtherParameter('SocialNetworks', 'OtherSocialNetworks', 'HasOtherSocialNetworks', socialNetwork, 3);
    }

    updateGameinformationourcesEvent(event: MouseEvent) {
      const target = <HTMLInputElement>event.target;
      this.updateParameter('Gameinformationources', 'OtherGameinformationources', 'HasOtherGameinformationources', target.value, target.checked, 4);
    }

    updateOtherGameinformationources(parameter: string, gameinformationource: string) {
      this.updateOtherParameter('Gameinformationources', 'OtherGameinformationources', 'HasOtherGameinformationources', gameinformationource, 4);
    }

    setHasInfluencers(hasInfluencers: boolean) {
      this.$set(this.$data.survey, 'HasInfluencers', hasInfluencers);

      if (!hasInfluencers) {
        this.$set(this.$data.survey, 'Influencers', null);
      }

      this.updateStepStatus(5, 'Influencers');
    }

    setInfluencers(parameter: string, influencers: string) {
      this.$set(this.$data.survey, 'Influencers', [influencers]);
      this.updateStepStatus(5, 'Influencers');
    }

    updateGamingWebsitesEvent(event: MouseEvent) {
      const target = <HTMLInputElement>event.target;
      this.updateParameter('GamingWebsites', 'OtherGamingWebsites', 'HasOtherGamingWebsites', target.value, target.checked, 6);
    }

    updateOtherGamingWebsites(parameter: string, gamingWebsite: string) {
      this.updateOtherParameter('GamingWebsites', 'OtherGamingWebsites', 'HasOtherGamingWebsites', gamingWebsite, 6);
    }

    setHasOtherStudios(hasOtherStudios: boolean) {
      this.$set(this.$data.survey, 'HasOtherStudios', hasOtherStudios);

      if (!hasOtherStudios) {
        this.$set(this.$data.survey, 'OtherStudios', null);
      }

      this.updateStepStatus(8, 'OtherStudios');
    }

    setOtherStudios(parameter: string, otherStudios: string) {
      this.$set(this.$data.survey, 'OtherStudios', [otherStudios]);
      this.updateStepStatus(8, 'OtherStudios');
    }

    send() {
      if (this.$data.isSendLoading) {
        return;
      }

      this.$data.isSendLoading = true;

      const errors = {
        Age: this.notExists(this.$data.survey.Age),
        Gender: this.notExists(this.$data.survey.Gender),
        Country: this.isNullOrWhiteSpace(this.$data.survey.Country),
        DevType: this.notExists(this.$data.survey.DevType),
        FavoriteFeatures: this.hasNullOrWhiteSpace(this.$data.survey.FavoriteFeatures),
        SocialNetworks: this.hasNullOrWhiteSpace(this.$data.survey.SocialNetworks),
        Gameinformationources: this.hasNullOrWhiteSpace(this.$data.survey.Gameinformationources),
        Influencers: this.$data.survey.HasInfluencers == null,
        GamingWebsites: this.hasNullOrWhiteSpace(this.$data.survey.GamingWebsites),
        Reviews_GamingWebsite: this.notExists(this.$data.survey.Reviews_GamingWebsite),
        Reviews_Influencers: this.notExists(this.$data.survey.Reviews_Influencers),
        Reviews_Steam: this.notExists(this.$data.survey.Reviews_Steam),
        OtherStudios: this.$data.survey.HasOtherStudios == null
      } as IQualificationSurveyErrorModel;

      setTimeout(() => {
        this.$set(this.$data.survey, 'Errors', errors);

        if (!this.isValid(errors)) {
          this.$data.isSendLoading = false;
          return;
        }

        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "survey/qualification";
        const steamConnect: IConnectModel = this.$store.getters.connects.find((connect: IConnectModel) => connect.CanonicalName == "steam");

        if (steamConnect != null) {
          accountService.post<IQualificationSurveySubmitModel, object>(this, url,
            { ...this.$data.survey, SteamId: steamConnect.Id_Account, Username: this.$store.getters.user.Username },
            { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
            .then(() => {
              this.$data.isSendLoading = false;
              this.$router.push({ name: 'ConfirmQualificationSurvey' });
            })
            .catch(error => {
              this.$data.isSendLoading = false;
            });
        }
      }, 300);
    }

    isNullOrWhiteSpace(parameter: string): boolean {
      return parameter == null || parameter == "" || parameter == " ";
    }

    hasNullOrWhiteSpace(parameters: Array<string>): boolean {
      if (parameters == null || parameters.find(parameter => this.isNullOrWhiteSpace(parameter))) {
        return true;
      }

      return false;
    }

    notExists(parameter: any): boolean {
      return parameter == null;
    }

    isValid(errors: IQualificationSurveyErrorModel): boolean {
      if (Object.keys(errors).some(key => (errors as any)[key])) {
        return false;
      }

      return true;
    }
  }
